import { Card, CardContent, Skeleton, CardActions, Button } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { useProjectDetailsUserColumns } from '../helper/projectDetailsUserColumns'
import {
    defaultPageSize,
    availablePageSizes,
} from '@/schemas/searchParams/searchParamsPaginationSchema'
import { ProjectDetailsTableLayout } from './ProjectDetailsTableLayout'

export const ProjectDetailsPendingComponent: React.FC = () => {
    const { t } = useTranslation()
    const columns = useProjectDetailsUserColumns()

    return (
        <Card>
            <CardContent>
                <ProjectDetailsTableLayout
                    projectName={<Skeleton />}
                    description={<Skeleton />}
                    startDate={<Skeleton />}
                    endDate={<Skeleton />}
                    trackingType={<Skeleton />}
                    deleted={<Skeleton />}
                    color={<Skeleton />}
                />

                <DataGrid
                    sx={{ mt: 2 }}
                    rows={[]}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: defaultPageSize },
                        },
                    }}
                    pageSizeOptions={availablePageSizes}
                    disableRowSelectionOnClick={true}
                    loading={true}
                />
            </CardContent>

            <CardActions style={{ justifyContent: 'flex-end' }}>
                <Button disabled={true}>{t('common.back')}</Button>
                <Button disabled={true} variant={'outlined'}>
                    {t('common.edit')}
                </Button>
            </CardActions>
        </Card>
    )
}
